var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"i-ControlIcon i-MinimiseControlIcon fill-none",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M6 21V19H18V21H6Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }